
























import Vue from 'vue';

export default Vue.extend({
  props: {
    id: {
      default: ``,
      type: String,
    },
    label: {
      default: ``,
      type: String,
    },
    name: {
      default: ``,
      type: String,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    vValue: {
      required: true,
      type: [Boolean, Number, String],
    },
    value: {
      default: false,
      type: [Boolean, Number, String],
    },
  },
});
